import { Button } from "@material-ui/core";
import { runInAction } from "mobx";
import { observer } from "mobx-react-lite";
import React from "react";
import SystemLabel from "../../../system/SystemLabel/SystemLabel";

export const PreviousPage = observer(({ current, text, setActivePage }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <button
        className="cms-button"
        disabled={current.activePage == 1}
        onClick={() =>
          // runInAction(() => {
          //   current.activePage -= 1;
          // })
          setActivePage(current.activePage-1)
        }
      >
        {text || <SystemLabel name="PreviousPage" />}
      </button>
    </div>
  );
});
